import * as React from 'react'

import { Slot } from '@radix-ui/react-slot'

import { cn } from '@/lib/utils'

/** Section heading — DESIGN_SYSTEM scale → **`text-xl`**. */
type SectionTitleProps = React.ComponentProps<'h3'> & {
  asChild?: boolean
}

function SectionTitle({ className, asChild = false, ...props }: SectionTitleProps) {
  const Comp = asChild ? Slot : 'h3'
  return (
    <Comp
      data-slot="section-title"
      className={cn('text-xl font-semibold tracking-tight text-foreground', className)}
      {...props}
    />
  )
}

export { SectionTitle }
